import { useContext } from "react";
import { getById, getByIds } from "sprint-common-web";

import { DistributionListsDataContent } from "../../../../common/data/lookup-data-providers/DistributionListsDataProvider";
import { DeliveryEndpointType } from "../../../../common/types/DeliveryEndpointType";
import { useAdminDeliveryEndpointApi } from "../../api/useAdminDeliveryEndpointApi";
import { DeliveryEndpointContext } from "../../context/DeliveryEndpointContext";
import { EditSmartjogDeliveryEndpointFormInputs } from "./EditSmartjogDeliveryEndpointForm";

export const useEditSmartjogDeliveryEndpointForm = (deliveryEndpointId: string) => {
    const { updateDeliveryEndpoint } = useAdminDeliveryEndpointApi();

    const { deliveryEndpointItems, updateSmartjogDeliveryEndpointItem } = useContext(DeliveryEndpointContext);
    const { distributionLists } = useContext(DistributionListsDataContent);

    const deliveryEndpoint = getById(deliveryEndpointItems, deliveryEndpointId);

    const editDeliveryEndpoint = async ({
        name,
        distributionListIds
    }: EditSmartjogDeliveryEndpointFormInputs): Promise<void> => {
        const parsedDistributionListIds = distributionListIds.map((item) => Number(item));

        const currentDistributionLists = getByIds(distributionLists, parsedDistributionListIds);

        await updateDeliveryEndpoint({
            id: deliveryEndpointId,
            name,
            type: DeliveryEndpointType.Smartjog,
            distributionLists: currentDistributionLists.map((item) => ({ id: item.id, name: item.name }))
        });

        updateSmartjogDeliveryEndpointItem({
            id: deliveryEndpointId,
            name,
            details: { distributionLists: currentDistributionLists, type: DeliveryEndpointType.Smartjog },
            type: DeliveryEndpointType.Smartjog,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        deliveryEndpoint,
        distributionLists,
        editDeliveryEndpoint
    };
};
